export default __webpack_public_path__ + "static/media/benefits_desc3.e1d94e16.png";